export default function init() {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initStateCities);
    } else {
        initStateCities();
    }
}

function initStateCities() {
    const filterLetters = document.querySelectorAll('.filter-letter');
    const citiesContainer = document.querySelector('.cities-container');
    const letterSections = document.querySelectorAll('.letter-section');
    const filterLettersContainer = document.querySelector('.filter-letters');
    const cityListingsContainer = document.querySelector('.city-listings-container');
    const cityListingsContainerHeader = document.querySelector('.city-listings-container .header-row');
    const flexGrid = document.querySelector('.city-listings .flex-grid');

    if (!filterLetters.length || !citiesContainer) return;

    function handleMobileLayout() {
        if (window.innerWidth <= 992) {
            if (filterLettersContainer && cityListingsContainer && flexGrid) {
                if (filterLettersContainer.parentElement === cityListingsContainerHeader) {
                    flexGrid.insertBefore(filterLettersContainer, cityListingsContainer);
                }
            }
        } else {
            if (filterLettersContainer && cityListingsContainer) {
                const headerRow = cityListingsContainer.querySelector('.header-row');
                if (headerRow && filterLettersContainer.parentElement !== cityListingsContainerHeader) {
                    headerRow.appendChild(filterLettersContainer);
                }
            }
        }
    }

    handleMobileLayout();
    window.addEventListener('resize', handleMobileLayout);

    let lastScrollTop = 0;
    const SCROLL_THRESHOLD = 10;
    let isProgrammaticScroll = false;

    function getVisibleLetters(first = true) {
        const containerHeight = citiesContainer.clientHeight;
        const visibleLetters = [];

        letterSections.forEach(section => {
            const rect = section.getBoundingClientRect();
            const containerRect = citiesContainer.getBoundingClientRect();

            const sectionTop = rect.top - containerRect.top;
            const sectionBottom = sectionTop + rect.height;

            if (sectionTop < containerHeight && sectionBottom > 0) {
                const letter = section.id.replace('letter-', '');
                visibleLetters.push(letter);
            }
        });

        if (visibleLetters.length === 0) return null;
        return first ? visibleLetters[0] : visibleLetters[visibleLetters.length - 1];
    }

    function setActiveLetter(letter) {
        if (letter) {
            filterLetters.forEach(letter => letter.classList.remove('active'));
            const targetLetterElement = document.querySelector(`[data-letter="${letter}"]`);
            if (targetLetterElement && targetLetterElement.classList.contains('enabled')) {
                targetLetterElement.classList.add('active');
            }
        }
    }

    function handleScroll() {
        if (isProgrammaticScroll) return;

        const currentScrollTop = citiesContainer.scrollTop;
        const scrollDifference = Math.abs(currentScrollTop - lastScrollTop);

        if (scrollDifference >= SCROLL_THRESHOLD) {
            const isScrollingDown = currentScrollTop > lastScrollTop;
            const targetLetter = isScrollingDown ? getVisibleLetters(false) : getVisibleLetters(true);

            setActiveLetter(targetLetter);
            lastScrollTop = currentScrollTop;
        }
    }

    function scrollToLetter(letter) {
        const targetSection = document.getElementById(`letter-${letter}`);
        if (targetSection) {
            isProgrammaticScroll = true;
            setActiveLetter(letter);

            citiesContainer.scrollTo({
                top: targetSection.offsetTop - citiesContainer.offsetTop,
                behavior: 'smooth',
            });

            setTimeout(() => {
                isProgrammaticScroll = false;
            }, 1000);
        }
    }

    filterLetters.forEach(letter => {
        letter.addEventListener('click', function () {
            if (this.classList.contains('enabled')) {
                const letterValue = this.getAttribute('data-letter');
                scrollToLetter(letterValue);
                const event = {
                    'event': 'on_page_link_click',
                    'elementPlacement': 'city_listings',
                    'elementClicked': 'letter_filter',
                    'pageUrl': window.location.href,
                    'position': 'single',
                    'linkText': letterValue,
                    'direction': 'forward',
                };
                console.log(event);
                window.dataLayer.push(event);
            }
        });
    });

    const cityLinks = document.querySelectorAll('.city-link');
    cityLinks.forEach(link => {
        link.addEventListener('click', function () {
            const event = {
                'event': 'internal_link_click',
                'elementPlacement': 'city_listings',
                'elementClicked': 'city_link',
                'position': 'single',
                'href': this.href,
                'linkText': this.textContent.trim(),
            };
            console.log(event);
            window.dataLayer.push(event);
        });
    });

    citiesContainer.addEventListener('scroll', handleScroll, { passive: true });
}